import { Component, inject, Input, OnInit, signal, WritableSignal } from '@angular/core';
import { ResidentsService } from '@modules/universal-billing/residents/residents.service';
import { AutocompleteComponent } from '@shared/components/autocomplete/autocomplete.component';
import { BasicForm } from '@shared/components/classes/basic.form';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { InputValidatorDirective } from '@common/directive/input-validator.directive';
import { FullNamePipe } from '@common/pipe/full-name.pipe';
import { CalendarModule } from '@primeng/calendar';
import { TranslatePipe } from '@ngx-translate/core';
import { Apartment, RenterInformation } from '@modules/universal-billing/apartments/apartments.interface';
import { Resident } from '@modules/universal-billing/residents/residents.interfaces';
import {
  RenterInformationComponent
} from '@modules/universal-billing/apartments/apartment-profile/renter-information/renter-information.component';
import { DatePipe, TitleCasePipe } from '@angular/common';
import { EmptyResultComponent } from '@shared/components/empty-result/empty-result.component';
import { FieldsetComponent } from '@shared/components/fieldset/fieldset.component';
import { Renters } from '@modules/universal-billing/renters/renters.interfaces';

@Component({
  selector: 'app-select-assign-renter',
  standalone: true,
  imports: [
    AutocompleteComponent,
    ReactiveFormsModule,
    InputValidatorDirective,
    FullNamePipe,
    CalendarModule,
    TranslatePipe,
    RenterInformationComponent,
    DatePipe,
    EmptyResultComponent,
    TitleCasePipe,
    FieldsetComponent
  ],
  templateUrl: './select-assign-renter.component.html',
  styleUrl: './select-assign-renter.component.scss'
})
export class SelectAssignRenterComponent extends BasicForm<any>{
  @Input() apartment: Apartment;

  _defaultService: ResidentsService = inject(ResidentsService);
  selectedResident: WritableSignal<RenterInformation> = signal(undefined);
  dateFields = ['startDate'];

  form: FormGroup = new FormGroup({
    apartmentId: new FormControl(null, Validators.required),
    residentId: new FormControl(null, Validators.required),
    startDate: new FormControl(null, Validators.required),
  });

  ngOnInit() {
    super.ngOnInit();
    this.form.get('apartmentId').setValue(this.apartment?.id);
  }

  submitAction(data: any): Observable<any> {
    return this._defaultService.assignResident(data);
  }

  selectResident(renter: any) {
    if (renter) {
      this.selectedResident.set({
        fullName: [renter.firstName, renter.middleName, renter.lastName].join(' '),
        idCard: renter.idCardNumber,
        taxCode: renter.taxCode,
        email: renter.email,
        phone: renter.phoneNumber,
        socialStatus: renter.socialStatus,
        birthDate: new Date(renter.birthDate),
        accountNo: renter.bankAccount,
        rentType: renter.rentType
      });
    }
    else {
      this.selectedResident.set(undefined);
    }

  }
}
